// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.battery-capacity-container {
  margin: 0;
}

.battery-capacity-indicator.size-small {
  transform: translateY(6px);
}

.battery-capacity-indicator.size-normal {
  transform: scale(1.3) translateY(2px);
  margin-right: 5px;
}

.battery-capacity-value {
  margin: 0;
}

.error-capacity-level {
  fill: #F00;
}

.warning-capacity-level {
  fill: #FF0;
}

.normal-capacity-level {
  fill: #0F0;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/dev/battery-state-monitor/battery-state-monitor.component.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;AACJ;;AACA;EACI,0BAAA;AAEJ;;AAAA;EACI,qCAAA;EACA,iBAAA;AAGJ;;AADA;EACI,SAAA;AAIJ;;AAFA;EACI,UAAA;AAKJ;;AAHA;EACI,UAAA;AAMJ;;AAJA;EACI,UAAA;AAOJ","sourcesContent":[".battery-capacity-container {\n    margin: 0;\n}\n.battery-capacity-indicator.size-small {\n    transform: translateY(6px);\n}\n.battery-capacity-indicator.size-normal {\n    transform: scale(1.3) translateY(2px);\n    margin-right: 5px;\n}\n.battery-capacity-value {\n    margin: 0;\n}\n.error-capacity-level {\n    fill: #F00;\n}\n.warning-capacity-level {\n    fill: #FF0;\n}\n.normal-capacity-level {\n    fill: #0F0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
